import styled from 'styled-components';

export const WalkthroughSvg = styled.svg`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  pointer-events: none;
  animation: fadeIn 0.4s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const SpotlightDot = styled.div<{ top: number; left: number }>`
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  width: 9px;
  height: 9px;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.dark};
  border-radius: 50%;
  box-shadow: 0 0 0 1px white;
  z-index: 10001;
  pointer-events: none;
`;

export const Tooltip = styled.div<{ top: number; left: number; position?: 'right' | 'bottom' | 'top' }>`
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  background: ${({ theme }) => theme.colorPalette.white};
  padding: 16px;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 320px;
  z-index: 10000;
  pointer-events: all;
  transform: ${({ position }) =>
    position === 'right' ? 'translateY(-50%)' : position === 'top' ? 'translate(-50%, -100%)' : 'translateX(-50%)'};
  animation: fadeIn 0.4s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  ${({ position, theme }) =>
    position === 'right' &&
    `
    &::before {
      content: '';
      position: absolute;
      left: -8px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 8px solid ${theme.colorPalette.white};
      filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.1));
    }
  `}

  ${({ position, theme }) =>
    position === 'bottom' &&
    `
    &::before {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid ${theme.colorPalette.white};
      filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
    }
  `}

  ${({ position, theme }) =>
    position === 'top' &&
    `
    &::before {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid ${theme.colorPalette.white};
      filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
    }
  `}
`;

export const TooltipTitle = styled.h3`
  margin: 0 0 8px 0;
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: 600;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const TooltipDescription = styled.p`
  margin: 0 0 16px 0;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  line-height: 1.5;
`;

export const TooltipActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const StepCounter = styled.div`
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  font-weight: 500;
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey7 : theme.colorPalette.grey.grey9};
  margin-bottom: 8px;
`;
